(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('cartPage', () => ({
      updating: false,
      error: '',

      async updateQuantity(line, quantity) {
        if (this.updating) return;

        const parsedQuantity = parseInt(quantity);
        if (parsedQuantity < 0 || isNaN(parsedQuantity)) return;

        this.updating = true;
        this.error = '';

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: line,
              quantity: parsedQuantity,
            }),
          });

          if (response.ok) {
            // Refresh Alpine cart store reactively, then reload page to update server-rendered content
            await Alpine.store('cart').refresh();
            window.location.reload();
          } else {
            const errorData = await response.json().catch(() => ({}));
            this.error = errorData.message || errorData.description || 'Could not update quantity. Please try again.';
          }
        } catch (error) {
          console.error('Error updating quantity:', error);
          this.error = 'Could not update quantity. Please try again.';
        } finally {
          this.updating = false;
        }
      },

      async removeItem(line) {
        await this.updateQuantity(line, 0);
      },
    }));

    Alpine.data('cartUpsells', () => ({
      slider: null,
      currentSlide: 0,
      totalSlides: 0,

      initSlider() {
        if (!this.$refs.sliderContainer) return;

        // Check if KeenSlider is available
        if (typeof KeenSlider === 'undefined') {
          console.error('KeenSlider is not loaded');
          return;
        }

        this.slider = new KeenSlider(this.$refs.sliderContainer, {
          slides: {
            perView: 1,
            spacing: 0,
            origin: 'center',
          },
          loop: true,
          renderMode: 'precision',
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel;
          },
        });

        // Get total number of slides
        this.totalSlides = this.slider.track.details.slides.length;
      },

      nextSlide() {
        if (this.slider) this.slider.next();
      },

      prevSlide() {
        if (this.slider) this.slider.prev();
      },

      goToSlide(idx) {
        if (this.slider) this.slider.moveToIdx(idx);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  window.toggleMobileFilters = function() {
    const filters = document.getElementById('mobile-filters');
    const backdrop = document.getElementById('filters-backdrop');

    if (filters && backdrop) {
      filters.classList.toggle('active');
      backdrop.classList.toggle('active');

      // Prevent body scroll when filters are open
      if (filters.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  };

  window.applyFilters = function() {
    const form = document.getElementById('collection-filters-form');
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);

    // Preserve sort order
    const sortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (sortBy) {
      params.set('sort_by', sortBy);
    }

    window.location.search = params.toString();
  };

  window.applySorting = function(sortValue) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    window.location.href = url.toString();
  };

  window.clearAllFilters = function() {
    const url = new URL(window.location.href);
    const sortBy = url.searchParams.get('sort_by');

    // Clear all params
    window.history.replaceState({}, '', url.pathname + (sortBy ? '?sort_by=' + sortBy : ''));
    window.location.reload();
  };

  // Show clear all button if filters are active
  document.addEventListener('DOMContentLoaded', function() {
    const activeFilters = document.querySelectorAll('.collection__active-filter');
    const clearButton = document.querySelector('.collection__filters-clear');

    if (activeFilters.length > 0 && clearButton) {
      clearButton.classList.remove('hidden');
    }

    // Close mobile filters on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const filters = document.getElementById('mobile-filters');
        if (filters && filters.classList.contains('active')) {
          window.toggleMobileFilters();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-activities"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Wait for Keen Slider to load
    if (typeof KeenSlider === 'undefined') {
      setTimeout(initSliders, 100);
    } else {
      initSliders();
    }
  });

  function initSliders() {
    if (typeof KeenSlider === 'undefined') {
      console.error('Keen Slider not loaded');
      return;
    }

    const sliders = document.querySelectorAll('.community-activities__slider');

    sliders.forEach((sliderElement) => {
      const sliderId = sliderElement.id;
      const blockId = sliderId.replace('slider-', '');
      const dotsContainer = document.querySelector(`.dots-${blockId}`);

      if (!sliderElement || !dotsContainer) return;

      // Count actual slides
      const slideCount = sliderElement.querySelectorAll('.keen-slider__slide').length;

      if (slideCount === 0) return;

      // Create dots
      for (let i = 0; i < slideCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        dotsContainer.appendChild(dot);
      }

      // Initialize slider
      const slider = new KeenSlider(sliderElement, {
        loop: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: (s) => {
          const dots = dotsContainer.querySelectorAll('.dot');
          dots.forEach((dot, idx) => {
            if (idx === s.track.details.rel) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        },
      });

      // Auto-play
      let autoplayInterval = setInterval(() => {
        if (slider) slider.next();
      }, 4000);

      // Pause on hover
      sliderElement.addEventListener('mouseenter', () => {
        clearInterval(autoplayInterval);
      });

      sliderElement.addEventListener('mouseleave', () => {
        autoplayInterval = setInterval(() => {
          if (slider) slider.next();
        }, 4000);
      });

      // Dot click handlers
      const dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          if (slider) slider.moveToIdx(idx);
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('addressesPage', () => ({
      showAddForm: false,
      editingAddress: null,

      editAddress(addressId) {
        this.editingAddress = addressId;
        // In a real implementation, you would populate the form with the address data
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('faqAccordion', () => ({
      open: null,

      init() {
        const firstOpen = this.$el.dataset.firstOpen;
        if (firstOpen === 'true') {
          this.open = 0;
        }
      },

      toggle(index) {
        this.open = this.open === index ? null : index;
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (typeof KeenSlider === 'undefined') return;

    const sliderEl = document.querySelector('.featured-collection__slider');
    if (!sliderEl) return;

    const prevBtn = document.querySelector('.featured-collection__arrow--prev');
    const nextBtn = document.querySelector('.featured-collection__arrow--next');
    const dotsContainer = document.querySelector('.featured-collection__dots');

    const slider = new KeenSlider(sliderEl, {
      loop: true,
      slides: {
        perView: 1,
        spacing: 24,
      },
      breakpoints: {
        '(min-width: 640px)': {
          slides: {
            perView: 2,
            spacing: 24,
          },
        },
        '(min-width: 1024px)': {
          slides: {
            perView: 3,
            spacing: 24,
          },
        },
        '(min-width: 1280px)': {
          slides: {
            perView: 4,
            spacing: 24,
          },
        },
      },
      created(s) {
        updateArrows(s);
        createDots(s);
      },
      slideChanged(s) {
        updateArrows(s);
        updateDots(s);
      },
    });

    function updateArrows(s) {
      // In loop mode, arrows are always enabled
      if (prevBtn) {
        prevBtn.disabled = false;
      }
      if (nextBtn) {
        nextBtn.disabled = false;
      }
    }

    function createDots(s) {
      if (!dotsContainer) return;

      const slides = s.track.details.slides;
      dotsContainer.innerHTML = '';

      slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.classList.add('featured-collection__dot');
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.addEventListener('click', () => s.moveToIdx(idx));
        dotsContainer.appendChild(dot);
      });

      updateDots(s);
    }

    function updateDots(s) {
      if (!dotsContainer) return;

      const dots = dotsContainer.querySelectorAll('.featured-collection__dot');
      dots.forEach((dot, idx) => {
        if (idx === s.track.details.rel) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => slider.prev());
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => slider.next());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky header scroll effect - add shadow when scrolled
  (function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    let ticking = false;

    function updateHeaderShadow() {
      const scrollY = window.scrollY;

      if (headerWrapper) {
        if (scrollY > 10) {
          headerWrapper.classList.add('scrolled');
        } else {
          headerWrapper.classList.remove('scrolled');
        }
      }

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderShadow);
        ticking = true;
      }
    }

    // Listen to scroll events
    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial call
    updateHeaderShadow();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  // Initialize marquee - works with or without Alpine
  (function() {
    function initMarquee() {
      const marqueeWrappers = document.querySelectorAll('.logo-marquee__marquee-wrapper');
      
      marqueeWrappers.forEach(wrapper => {
        const content = wrapper.querySelector('.logo-marquee__content');
        const item = wrapper.querySelector('.logo-marquee__item');
        
        if (!content || !item) return;
        
        // Check if already cloned by counting items
        const items = content.querySelectorAll('.logo-marquee__item');
        if (items.length < 2) {
          // Clone the item to create seamless loop
          const clone = item.cloneNode(true);
          content.appendChild(clone);
          
          // Add animated class to start animation
          content.classList.add('animated');
        } else if (!content.classList.contains('animated')) {
          // If already cloned but not animated, add the class
          content.classList.add('animated');
        }
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMarquee);
    } else {
      initMarquee();
    }

    // Also initialize after a short delay to ensure Alpine has processed
    setTimeout(initMarquee, 100);
    
    // And after Alpine loads if it hasn't yet
    if (typeof Alpine !== 'undefined') {
      document.addEventListener('alpine:init', initMarquee);
    } else {
      window.addEventListener('load', function() {
        setTimeout(initMarquee, 200);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-categories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (typeof KeenSlider === 'undefined') return;

    const container = document.querySelector('.main-categories__container');
    if (!container || container.dataset.slider !== 'true') return;

    const sliderEl = container.querySelector('.main-categories__track');
    if (!sliderEl) return;

    const prevBtn = container.querySelector('.main-categories__arrow--prev');
    const nextBtn = container.querySelector('.main-categories__arrow--next');
    const dotsContainer = container.querySelector('.main-categories__dots');

    const slider = new KeenSlider(sliderEl, {
      loop: true,
      slides: {
        perView: 1,
        spacing: 16,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 2,
            spacing: 16,
          },
        },
        '(min-width: 1024px)': {
          slides: {
            perView: 3,
            spacing: 16,
          },
        },
      },
      created(s) {
        updateArrows(s);
        createDots(s);
      },
      slideChanged(s) {
        updateArrows(s);
        updateDots(s);
      },
    });

    function updateArrows(s) {
      // In loop mode, arrows are always enabled
      if (prevBtn) {
        prevBtn.disabled = false;
      }
      if (nextBtn) {
        nextBtn.disabled = false;
      }
    }

    function createDots(s) {
      if (!dotsContainer) return;

      const slides = s.track.details.slides;
      dotsContainer.innerHTML = '';

      slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.classList.add('main-categories__dot');
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.addEventListener('click', () => s.moveToIdx(idx));
        dotsContainer.appendChild(dot);
      });

      updateDots(s);
    }

    function updateDots(s) {
      if (!dotsContainer) return;

      const dots = dotsContainer.querySelectorAll('.main-categories__dot');
      dots.forEach((dot, idx) => {
        if (idx === s.track.details.rel) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => slider.prev());
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => slider.next());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof KeenSlider === 'undefined') return;

    var sectionEls = document.querySelectorAll('.related-products');

    sectionEls.forEach(function (sectionEl) {
      var sliderEl = sectionEl.querySelector('.related-products__slider');
      if (!sliderEl) return;

      var prevBtn = sectionEl.querySelector('.related-products__arrow--prev');
      var nextBtn = sectionEl.querySelector('.related-products__arrow--next');
      var dotsContainer = sectionEl.querySelector('.related-products__dots');

      var slider = new KeenSlider(sliderEl, {
        loop: true,
        slides: {
          perView: 1,
          spacing: 24,
        },
        breakpoints: {
          '(min-width: 640px)': {
            slides: {
              perView: 2,
              spacing: 24,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 3,
              spacing: 24,
            },
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 4,
              spacing: 24,
            },
          },
        },
        created: function (s) {
          updateArrows(s);
          createDots(s);
        },
        slideChanged: function (s) {
          updateArrows(s);
          updateDots(s);
        },
      });

      function updateArrows(s) {
        // Loop mode: arrows are always enabled
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }

      function createDots(s) {
        if (!dotsContainer) return;

        var slides = s.track.details.slides;
        dotsContainer.innerHTML = '';

        slides.forEach(function (_, idx) {
          var dot = document.createElement('button');
          dot.classList.add('related-products__dot');
          dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          dot.addEventListener('click', function () {
            s.moveToIdx(idx);
          });
          dotsContainer.appendChild(dot);
        });

        updateDots(s);
      }

      function updateDots(s) {
        if (!dotsContainer) return;

        var dots = dotsContainer.querySelectorAll('.related-products__dot');
        dots.forEach(function (dot, idx) {
          if (idx === s.track.details.rel) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          slider.prev();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          slider.next();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('productPage', () => ({
      product: null,
      currentVariant: null,
      selectedOptions: { option1: null, option2: null, option3: null },
      quantity: 1,
      mainSlider: null,
      thumbSlider: null,
      selectedSellingPlan: null,

      init() {
        const productJson = document.getElementById('product-json');
        if (productJson) {
          this.product = JSON.parse(productJson.textContent);

          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');

          let initialVariant = null;
          if (variantId) {
            initialVariant = this.product.variants.find(v => v.id == variantId);
          }
          if (!initialVariant) {
            initialVariant = this.product.variants.find(v => v.available) || this.product.variants[0];
          }
          if (initialVariant) {
            this.selectedOptions.option1 = initialVariant.option1;
            this.selectedOptions.option2 = initialVariant.option2;
            this.selectedOptions.option3 = initialVariant.option3;
            this.currentVariant = initialVariant;
          }

          if (this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
            const firstGroup = this.product.selling_plan_groups[0];
            if (firstGroup.selling_plans && firstGroup.selling_plans.length > 0) {
              this.selectedSellingPlan = firstGroup.selling_plans[0].id;
            }
          }
        }

        this.$nextTick(() => { this.initializeSliders(); });
      },

      initializeSliders() {
        const mainElement = document.getElementById('product-gallery-main');
        const thumbElement = document.getElementById('product-gallery-thumbs');

        if (mainElement && typeof KeenSlider !== 'undefined') {
          this.mainSlider = new KeenSlider(mainElement, {
            loop: false,
            slides: { perView: 1, spacing: 0 },
          });

          const prevBtn = document.querySelector('.product__gallery-arrow--prev');
          const nextBtn = document.querySelector('.product__gallery-arrow--next');
          if (prevBtn) prevBtn.addEventListener('click', () => { if (this.mainSlider) this.mainSlider.prev(); });
          if (nextBtn) nextBtn.addEventListener('click', () => { if (this.mainSlider) this.mainSlider.next(); });
        }

        if (thumbElement && typeof KeenSlider !== 'undefined') {
          this.thumbSlider = new KeenSlider(thumbElement, {
            loop: false,
            mode: 'free-snap',
            slides: { perView: 'auto', spacing: 10 },
          });

          const thumbs = document.querySelectorAll('.product__gallery-thumb');
          thumbs.forEach((thumb, idx) => {
            thumb.addEventListener('click', () => { if (this.mainSlider) this.mainSlider.moveToIdx(idx); });
          });

          if (this.mainSlider) {
            this.mainSlider.on('slideChanged', (slider) => {
              thumbs.forEach(thumb => thumb.classList.remove('active'));
              const activeIndex = slider.track.details.rel;
              if (thumbs[activeIndex]) thumbs[activeIndex].classList.add('active');
            });
          }
          if (thumbs[0]) thumbs[0].classList.add('active');
        }
      },

      selectOption(optionPosition, value) {
        this.selectedOptions[`option${optionPosition}`] = value;
        const matchingVariant = this.product.variants.find(variant =>
          (!this.selectedOptions.option1 || variant.option1 === this.selectedOptions.option1) &&
          (!this.selectedOptions.option2 || variant.option2 === this.selectedOptions.option2) &&
          (!this.selectedOptions.option3 || variant.option3 === this.selectedOptions.option3)
        );
        if (matchingVariant) {
          this.currentVariant = matchingVariant;
          this.updateURL();
          this.switchToVariantMedia();
        }
      },

      isOptionValueAvailable(optionPosition, value) {
        return this.product.variants.some(variant => {
          if (variant[`option${optionPosition}`] !== value) return false;
          for (let i = 1; i <= 3; i++) {
            if (i === optionPosition) continue;
            const sel = this.selectedOptions[`option${i}`];
            if (sel && variant[`option${i}`] !== sel) return false;
          }
          return variant.available;
        });
      },

      switchToVariantMedia() {
        if (this.currentVariant.featured_media && this.mainSlider) {
          const slideIndex = Array.from(document.querySelectorAll('.product__gallery-slide')).findIndex(
            slide => slide.dataset.mediaId === this.currentVariant.featured_media.id.toString()
          );
          if (slideIndex !== -1) this.mainSlider.moveToIdx(slideIndex);
        }
      },

      updateURL() {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.currentVariant.id);
        window.history.replaceState({}, '', url);
      },

      formatMoney(cents) {
        return Shopify.formatMoney(cents);
      },

      async addToCart() {
        if (!this.currentVariant.available) return;
        const props = {};
        if (this.selectedSellingPlan) props.selling_plan = this.selectedSellingPlan;
        await window.addToCart(this.currentVariant.id, this.quantity, props);
      }
    }));

    // Recently Viewed Component
    Alpine.data('recentlyViewed', () => ({
      products: [],
      limit: 4,

      init() {
        this.limit = this.$el.closest('[data-limit]')?.dataset.limit || 4;
        this.loadRecentlyViewed();
        this.saveCurrentProduct();
      },

      saveCurrentProduct() {
        const productJson = document.getElementById('product-json');
        if (!productJson) return;
        try {
          const product = JSON.parse(productJson.textContent);
          const recentProducts = this.getRecentProducts();
          const productData = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            url: `/products/${product.handle}`,
            price: Shopify.formatMoney(product.price),
            image: product.featured_image ? product.featured_image.src : null
          };
          const filtered = recentProducts.filter(p => p.id !== product.id);
          filtered.unshift(productData);
          localStorage.setItem('recentlyViewedProducts', JSON.stringify(filtered.slice(0, parseInt(this.limit) + 1)));
        } catch (error) {
          console.error('Error saving recently viewed product:', error);
        }
      },

      loadRecentlyViewed() {
        try {
          const recentProducts = this.getRecentProducts();
          const productJson = document.getElementById('product-json');
          if (productJson) {
            const currentProduct = JSON.parse(productJson.textContent);
            this.products = recentProducts.filter(p => p.id !== currentProduct.id).slice(0, parseInt(this.limit));
          } else {
            this.products = recentProducts.slice(0, parseInt(this.limit));
          }
        } catch (error) {
          console.error('Error loading recently viewed products:', error);
          this.products = [];
        }
      },

      getRecentProducts() {
        try {
          const stored = localStorage.getItem('recentlyViewedProducts');
          return stored ? JSON.parse(stored) : [];
        } catch (error) {
          return [];
        }
      }
    }));

    // Quick View Component
    Alpine.data('quickView', () => ({
      isOpen: false,
      product: null,
      currentVariant: null,
      currentImage: null,
      quantity: 1,
      selectedOptions: { option1: null, option2: null, option3: null },

      async openQuickView(productHandle) {
        this.isOpen = true;
        this.product = null;
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          const productData = await response.json();
          this.product = productData;
          this.currentVariant = productData.variants.find(v => v.available) || productData.variants[0];
          this.currentImage = (this.currentVariant.featured_image?.src || productData.featured_image || productData.media?.[0]?.src || productData.media?.[0]?.preview_image?.src);
          if (this.currentVariant) {
            this.selectedOptions.option1 = this.currentVariant.option1;
            this.selectedOptions.option2 = this.currentVariant.option2;
            this.selectedOptions.option3 = this.currentVariant.option3;
          }
        } catch (error) {
          console.error('Error loading product:', error);
          this.closeQuickView();
        }
      },

      closeQuickView() {
        this.isOpen = false;
        setTimeout(() => {
          this.product = null;
          this.currentVariant = null;
          this.currentImage = null;
          this.quantity = 1;
          this.selectedOptions = { option1: null, option2: null, option3: null };
        }, 300);
      },

      selectOption(optionPosition, value) {
        this.selectedOptions[`option${optionPosition}`] = value;
        const match = this.product.variants.find(v =>
          (!this.selectedOptions.option1 || v.option1 === this.selectedOptions.option1) &&
          (!this.selectedOptions.option2 || v.option2 === this.selectedOptions.option2) &&
          (!this.selectedOptions.option3 || v.option3 === this.selectedOptions.option3)
        );
        if (match) {
          this.currentVariant = match;
          if (match.featured_image?.src) this.currentImage = match.featured_image.src;
        }
      },

      isOptionValueAvailable(optionPosition, value) {
        return this.product.variants.some(variant => {
          if (variant[`option${optionPosition}`] !== value) return false;
          for (let i = 1; i <= 3; i++) {
            if (i === optionPosition) continue;
            const sel = this.selectedOptions[`option${i}`];
            if (sel && variant[`option${i}`] !== sel) return false;
          }
          return variant.available;
        });
      },

      formatMoney(cents) {
        return Shopify.formatMoney(cents);
      },

      async addToCart() {
        if (!this.currentVariant.available) return;
        await window.addToCart(this.currentVariant.id, this.quantity, {});
        this.closeQuickView();
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wayfinder-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('wfFeaturedProduct', () => ({
      selectedVariant: null,
      selectedOptions: { option1: null, option2: null, option3: null },
      variants: [],
      moneyFormat: '',
      productImageUrl: '',
      secondaryImageUrl: '',
      isAvailable: true,
      addToCartState: 'idle',
      maxVisibleOptions: 10,
      sellingPlanGroups: [],
      requiresSellingPlan: false,
      selectedSellingPlan: null,

      init() {
        const cardId = this.$el.dataset.productCardId;
        const scriptTag = this.$el.querySelector(`script[data-product-card-data="${cardId}"]`);
        if (!scriptTag) return;

        try {
          const data = JSON.parse(scriptTag.textContent);
          this.variants = data.variants || [];
          this.moneyFormat = data.moneyFormat || ['$', '{', '{amount}}'].join('');
          this.productImageUrl = data.productImageUrl || '';
          this.maxVisibleOptions = data.maxVisibleOptions || 10;
          this.sellingPlanGroups = data.sellingPlanGroups || [];
          this.requiresSellingPlan = data.requiresSellingPlan || false;

          // Auto-select first selling plan if required
          if (this.sellingPlanGroups.length > 0 && this.sellingPlanGroups[0].selling_plans.length > 0) {
            this.selectedSellingPlan = this.sellingPlanGroups[0].selling_plans[0].id;
          }

          const initialVariant = this.variants.find(v => v.id === data.variantId) || this.variants[0];
          if (initialVariant) {
            this.selectedOptions.option1 = initialVariant.option1 || null;
            this.selectedOptions.option2 = initialVariant.option2 || null;
            this.selectedOptions.option3 = initialVariant.option3 || null;
            this.selectedVariant = initialVariant.id;
          }

          this.checkAvailability();
          this.updatePrice();
          this.updateImage();
        } catch (e) {
          console.error('Error parsing featured product data:', e);
        }
      },

      async handleAddToCart() {
        if (!this.isAvailable || this.addToCartState === 'loading') return;
        if (this.requiresSellingPlan && !this.selectedSellingPlan) return;

        this.addToCartState = 'loading';
        try {
          const props = {};
          if (this.selectedSellingPlan) {
            props.selling_plan = this.selectedSellingPlan;
          }
          await window.addToCart(this.selectedVariant, 1, props);
          this.addToCartState = 'success';
          setTimeout(() => { this.addToCartState = 'idle'; }, 2000);
        } catch (error) {
          console.error('Error adding to cart:', error);
          this.addToCartState = 'idle';
        }
      },

      checkAvailability() {
        const variant = this.variants.find(v => v.id === this.selectedVariant);
        this.isAvailable = variant?.available ?? false;
      },

      updatePrice() {
        const variant = this.variants.find(v => v.id === this.selectedVariant);
        if (!variant || !this.$refs.price) return;
        this.$refs.price.textContent = Shopify.formatMoney(variant.price);
        if (this.$refs.comparePrice) {
          const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          this.$refs.comparePrice.style.display = hasCompare ? 'inline' : 'none';
          if (hasCompare) {
            this.$refs.comparePrice.textContent = Shopify.formatMoney(variant.compare_at_price);
          }
        }
      },

      updateImage() {
        const variant = this.variants.find(v => v.id === this.selectedVariant);
        if (!variant || !this.$refs.image) return;
        const imageUrl = variant.featured_image?.src || this.productImageUrl;
        if (imageUrl) {
          this.$refs.image.src = imageUrl;
        }
      },

      selectOption(optionPosition, value) {
        this.selectedOptions[`option${optionPosition}`] = value;
        const match = this.variants.find(v =>
          (!this.selectedOptions.option1 || v.option1 === this.selectedOptions.option1) &&
          (!this.selectedOptions.option2 || v.option2 === this.selectedOptions.option2) &&
          (!this.selectedOptions.option3 || v.option3 === this.selectedOptions.option3)
        );
        if (match) {
          this.selectedVariant = match.id;
          this.checkAvailability();
          this.updatePrice();
          this.updateImage();
        }
      },

      isOptionValueAvailable(optionPosition, value) {
        return this.variants.some(v => {
          if (v[`option${optionPosition}`] !== value) return false;
          for (let i = 1; i <= 3; i++) {
            if (i === optionPosition) continue;
            const sel = this.selectedOptions[`option${i}`];
            if (sel && sel !== 'null' && sel !== '' && v[`option${i}`] !== sel) return false;
          }
          return v.available === true;
        });
      }
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
